/**
 * Hook to create title container props
 *
 * Note: Since this returns a static object with no dependencies,
 * the memoization is not needed as it will not be affecting any functionality.
 * However, memoization prevents object identity changes between renders,
 * which can help prevent unnecessary re-renders in child components.
 */
var useTitleContainerProps = function useTitleContainerProps() {
  return (
    // Simple static object can be returned directly
    {
      direction: 'column',
      alignItems: 'flex-start',
      width: '100%'
    }
  );
};

export { useTitleContainerProps };
//# sourceMappingURL=useTitleContainerProps.js.map
